module.exports = __webpack_public_path__ + "static/media/star.11294654.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Layout/images/star.svg
// module id = 1384
// module chunks = 0